import { FC } from 'react';

type Props = {
	className?: string;
};

const LocationIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.2948 17.4933C10.9479 17.8181 10.4841 17.9997 10.0015 17.9997C9.51888 17.9997 9.05521 17.8181 8.70826 17.4933C5.53114 14.5005 1.27342 11.1573 3.34979 6.30364C4.47245 3.67929 7.16736 2 10.0015 2C12.8357 2 15.5306 3.67929 16.6533 6.30364C18.727 11.1513 14.4797 14.5109 11.2948 17.4933Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M12.7991 9.19985C12.7991 10.7462 11.5455 11.9998 9.99916 11.9998C8.45279 11.9998 7.19922 10.7462 7.19922 9.19985C7.19922 7.65348 8.45279 6.3999 9.99916 6.3999C11.5455 6.3999 12.7991 7.65348 12.7991 9.19985Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
		</svg>
	);
};

export default LocationIcon;
